import { defineStore } from 'pinia';
import { computed, ComputedRef, Ref, ref } from 'vue';
import { RouteLocationNormalized, RouteParamValue } from 'vue-router';

export const useRouteStore = defineStore('Route', () => {
  const currentRoute: Ref<RouteLocationNormalized | null> = ref(null);

  const route: ComputedRef<RouteLocationNormalized | null> = computed(() => {
    return currentRoute.value;
  });

  const routeParams: ComputedRef<Record<string, RouteParamValue> | null> = computed(() => {
    // Vue Router v4 changed the param value type to string | string[] - continue using type from previous version
    return route.value ? route.value.params as Record<string, RouteParamValue> : null;
  });

  function routeChanged(newRoute: RouteLocationNormalized) {
    currentRoute.value = newRoute;
  }

  return {
    route,
    routeParams,
    routeChanged
  };
});
